import React, { useEffect, useState } from "react";
import { View, StyleSheet } from "react-native";
import Text from "components/Text";
import {
  Cursor,
  CodeField,
  useBlurOnFulfill,
  useClearByFocusCell,
} from "react-native-confirmation-code-field";

import { colors } from "assets/constants";
import { useRecoilValue } from "recoil";
import { authAtom } from "stores";
import { mq } from "utils";

const VERIFY_CODE_LENGTH = 5;

const FIELD_WIDTH = mq(30);
const MARGIN = mq(15);
const ROOT_WIDTH =
  VERIFY_CODE_LENGTH * Number(FIELD_WIDTH) +
  (VERIFY_CODE_LENGTH - 1) * Number(MARGIN);

export default function CodeInput(props: {
  code?: string;
  getValue: (inputCode: string) => void;
}) {
  const { getValue, code = "" } = props;
  const {
    company: { color },
  } = useRecoilValue(authAtom);

  const [value, setValue] = useState(code);

  useEffect(() => {
    setValue(code);
  }, [code]);

  const ref = useBlurOnFulfill({ value, cellCount: VERIFY_CODE_LENGTH });
  const [codeFieldProps, getCellOnLayoutHandler] = useClearByFocusCell({
    value,
    setValue,
  });

  return (
    <CodeField
      ref={ref}
      {...codeFieldProps}
      value={value}
      onChangeText={(inputCode) => {
        setValue(inputCode);
        getValue && getValue(inputCode);
      }}
      cellCount={VERIFY_CODE_LENGTH}
      rootStyle={{ width: ROOT_WIDTH }}
      keyboardType="number-pad"
      textContentType="oneTimeCode"
      autoFocus
      renderCell={({ index, symbol, isFocused }) => (
        <View
          style={{
            ...styles.cellContainer,
            borderBottomWidth: isFocused ? 2 : 1,
            borderBottomColor: isFocused ? color : colors.textColorGray,
          }}
          key={index + ""}
          onLayout={getCellOnLayoutHandler(index)}
        >
          <Text align="center" size={"xxl"} weight="medium">
            {symbol || (isFocused ? <Cursor /> : null)}
          </Text>
        </View>
      )}
    />
  );
}

const styles = StyleSheet.create({
  cellContainer: {
    width: mq(30),
    height: mq(35),
    alignItems: "center",
    justifyContent: "center",
  },
});
